import React from "react";

import {
    faArrowDown,
    faArrowUp,
    faCircleCheck,
    faCircleMinus,
    faCircleQuestion,
    faCircleUser,
    faCircleXmark,
    faMagnifyingGlassPlus,
    faPrint,
    faStar,
    faTriangleExclamation,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
    FontAwesomeIcon,
    FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

type IconProps = Omit<FontAwesomeIconProps, "icon">;

export const UserIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleUser} {...props} />;
};

export const MagnifyingGlassIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faMagnifyingGlassPlus} {...props} />;
};

export const StarIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faStar} {...props} />;
};

export const CloseIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faXmark} {...props} />;
};

export const PrintIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faPrint} {...props} />;
};

export const UpArrowIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faArrowUp} {...props} />;
};

export const DownArrowIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faArrowDown} {...props} />;
};

export const CheckIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleCheck} {...props} />;
};

export const XIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleXmark} {...props} />;
};

export const DashIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleMinus} {...props} />;
};

export const QuestionIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleQuestion} {...props} />;
};

export const ExclamationTriangleIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faTriangleExclamation} {...props} />;
};
